<template>
  <div class="page support-page">
    <div class="breadcrumb__container">
      <a-breadcrumb class="breadcrumb">
        <a-breadcrumb-item v-for="(item, i) in breadcrumbs" :key="i" class="breadcrumb__link">
          {{ item }}
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div >
      <h1>Обращение в техническую поддержку</h1>

      <div class="block-wrapper">
        <a-row type="flex" :gutter="20">
          <a-col flex="1">
            <a-form-model :model="form" :labelCol="labelCol" :wrapperCol="wrapperCol"
                          :colon="false">
              <a-form-model-item label="Тема" labelAlign="left">
                <a-input v-model="form.theme" size="large"/>
              </a-form-model-item>
              <a-form-model-item label="ФИО" labelAlign="left">
                <a-input v-model="form.fullName" size="large"/>
              </a-form-model-item>
              <a-form-model-item label="E-mail" labelAlign="left">
                <a-input v-model="form.email" size="large"/>
              </a-form-model-item>
              <a-form-model-item label="Текст сообщения" labelAlign="left">
                <a-textarea v-model="form.message" rows="10" size="large"/>
              </a-form-model-item>
              <a-form-model-item label=" ">
                <a-space :size="10">
                  <a-button type="primary" size="large"> Отправить</a-button>
                  <a-button class="btn-secondary" icon="paper-clip" size="large">
                    Прикрепить файл
                  </a-button>
                </a-space>
              </a-form-model-item>
            </a-form-model>
          </a-col>

          <a-col flex="1" class="contacts">
            <a-row type="flex" justify="center">
              <a-col>
                <h2 class="header">Служба технической и<br/>консультационной поддержки:</h2>

                <a-row type="flex" :gutter="[20, 60]">
                  <a-col>
                    <a-icon type="mail" class="secondary-text"/>
                  </a-col>
                  <a-col>{{ contacts.email }}</a-col>
                </a-row>
                <a-row type="flex" :gutter="[20, 60]">
                  <a-col>
                    <a-icon type="instagram" class="secondary-text"/>
                  </a-col>
                  <a-col>{{ contacts.telegram }}</a-col>
                </a-row>
                <a-row type="flex" :gutter="[20, 60]">
                  <a-col>
                    <a-icon type="phone" class="secondary-text"/>
                  </a-col>
                  <a-col>{{ contacts.phone }}</a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupportPage',

  data: () => ({
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
    form: {
      theme: '',
      fullName: '',
      email: '',
      message: '',
    },
    contacts: {
      email: 'example@example.com',
      telegram: '@example_telegram',
      phone: '+7 000 000-00-00',
    },
      breadcrumbs: ["Главная", "Обращение в тех. поддержку"]
  }),
};
</script>

<style lang="scss">
.support-page {
  .ant-input {
    border: 2px solid #e1eaf5;
  }
  .contacts {
    .header {
      margin-bottom: 40px;
    }

    .anticon {
      font-size: 1.8rem;
    }
  }
}
.breadcrumb__container {
  padding: 0 !important;
}
</style>
